var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 44,
    viewBox: "0 0 51 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.992 2.7792C26.992 2.7792 25.3041 1.25462 27.9401 1.59243C29.8501 1.82172 29.1615 1.09032 29.9798 0.862639C30.7774 0.6344 32.5388 0.966669 32.8769 1.56393C33.3545 2.39664 33.9306 2.66159 34.6779 2.75286C35.4253 2.84413 36.4667 3.62061 35.6479 3.8661C34.8291 4.11159 33.7587 3.63737 32.5373 4.13948C31.3159 4.64159 29.8506 4.13899 29.8506 4.13899C29.8506 4.13899 28.3853 3.63638 27.164 4.13849C25.9426 4.64061 26.9915 2.79701 26.9915 2.79701L26.992 2.7792Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8748 4.02401C28.8748 4.02401 28.4195 5.4735 28.8733 7.19682C29.3654 9.04595 29.2297 11.7874 29.2459 11.1818",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2917 3.96364C33.2917 3.96364 33.2279 6.35049 32.1146 8.26366C31.0013 10.1768 31.0872 11.6408 31.0872 11.6408",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5825 14.1666C29.419 13.271 29.1322 11.5343 29.1375 10.5541L29.9079 11.3411L31.0817 10.2852C31.0817 10.2852 31.0557 12.8156 30.958 14.1321C30.9504 14.4171 30.6737 14.6414 30.3392 14.6859C29.9637 14.7116 29.6364 14.4889 29.582 14.1844L29.5825 14.1666Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9931 2.68099C31.9931 2.68099 31.1526 2.17726 30.1891 2.38324",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5755 4.22081C37.5755 4.22081 37.0886 2.17575 39.1317 3.65635C40.6234 4.73006 40.503 3.78211 41.3312 3.96467C42.1599 4.12941 43.443 5.21538 43.3629 5.87277C43.2554 6.77897 43.5755 7.2688 44.1473 7.69405C44.7191 8.11931 45.1267 9.23535 44.298 9.07061C43.4693 8.90586 42.8475 8.01582 41.4762 7.89005C40.105 7.76428 39.197 6.67052 39.197 6.67052C39.197 6.67052 38.2682 5.5762 36.9178 5.45099C35.5673 5.32577 37.5958 4.23918 37.5958 4.23918L37.5755 4.22081Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4204 6.11452C38.4204 6.11452 37.1228 7.13152 36.4537 8.7892C35.7188 10.5699 33.93 12.8215 34.2976 12.3144",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2213 8.07014C42.2213 8.07014 40.669 10.0429 38.5355 11.1623C36.4021 12.2818 35.5561 13.5426 35.5561 13.5426",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7267 14.982C33.1445 14.1553 33.9787 12.5556 34.6046 11.7345L34.7861 12.7376L36.4412 12.3718C36.4412 12.3718 34.8643 14.4865 33.9403 15.5491C33.7468 15.7757 33.3698 15.8547 33.0818 15.7223C32.7521 15.5887 32.5947 15.2458 32.7485 14.9469L32.7267 14.982Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5792 6.38628C41.1335 6.68629 41.7971 6.79315 41.8913 6.38569",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2075 17.0893C48.2075 17.0893 50.368 18.0739 49.2994 15.9776C48.5277 14.4597 49.5384 14.8254 49.5787 14.0957C49.6191 13.3659 48.7598 12.0061 48.013 11.897C46.9554 11.7261 46.508 11.322 46.1907 10.7253C45.8734 10.1286 44.7241 9.49185 44.6842 10.2038C44.6444 10.9157 45.4564 11.7039 45.2173 12.8561C44.9783 14.0084 45.9284 15.0854 45.9284 15.0854C45.9284 15.0854 46.8789 16.1447 46.6394 17.3147C46.4003 18.467 48.1862 17.1065 48.1862 17.1065L48.2075 17.0893Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3242 15.8619C46.3242 15.8619 44.8043 16.6235 42.7609 16.7115C40.551 16.795 37.5085 17.6406 38.1797 17.4625",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2143 12.196C45.2143 12.196 42.5506 12.8913 40.7005 14.3213C38.8503 15.7514 37.1753 16.0809 37.1753 16.0809",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7294 17.9762C35.7734 17.8794 37.7998 17.6483 38.9109 17.375L37.8188 16.9358L38.6851 15.6934C38.6851 15.6934 35.855 16.3842 34.4061 16.8268C34.091 16.9253 33.8961 17.2053 33.9514 17.4742C34.0053 17.7965 34.3538 18.0019 34.7294 17.9762Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0067 12.9217C47.0067 12.9217 47.8041 13.4777 47.8229 14.3338",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.06 15.7577L30.0432 17.9765",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0327 17.5477L30.1478 17.9608",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3398 14.6686L30.0833 18.0307C29.4598 18.7627 28.7951 19.4757 28.1105 20.1526L24.6065 28.1337L22.3155 24.2401C21.668 23.5276 20.9998 22.8146 20.289 22.1361L16.5027 21.1971",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24984 21.4585C2.24984 21.4585 0.179765 22.544 1.07033 20.3931C1.71577 18.8418 0.746508 19.2615 0.641149 18.5279C0.535315 17.812 1.28101 16.4059 2.0142 16.2473C3.06148 16.0257 3.46834 15.6088 3.73475 14.992C4.00115 14.3753 5.08162 13.6912 5.18745 14.407C5.29329 15.1228 4.54249 15.9405 4.88712 17.0727C5.23176 18.2049 4.34799 19.3221 4.34799 19.3221C4.34799 19.3221 3.48503 20.4398 3.80886 21.5715C4.13268 22.7031 2.25079 21.4229 2.25079 21.4229L2.24984 21.4585Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03475 20.1337C4.03475 20.1337 5.59887 20.835 7.6612 20.8188C9.86921 20.8065 12.9749 21.4955 12.2909 21.3703",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84173 16.4295C4.84173 16.4295 7.55482 17.0011 9.51806 18.3548C11.4813 19.7085 13.1827 19.95 13.1827 19.95",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7802 21.7313C14.7405 21.6679 12.682 21.5416 11.5634 21.3156L12.6178 20.8269L11.6502 19.6246C11.6502 19.6246 14.5303 20.1828 16.0197 20.5613C16.3508 20.6414 16.5518 20.9142 16.5234 21.1986C16.494 21.5187 16.1756 21.7419 15.801 21.7319L15.7802 21.7313Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1332 17.2394C3.1332 17.2394 2.38811 17.8434 2.42818 18.6822",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97727 12.9127C5.97727 12.9127 3.54127 12.8833 5.64072 11.4777C7.16729 10.4668 6.06614 10.3661 6.41675 9.71595C6.76736 9.06579 8.26883 8.21466 8.99203 8.43006C10.0047 8.7245 10.6338 8.56306 11.228 8.15113C11.8222 7.73921 13.1986 7.66905 12.8272 8.31865C12.4766 8.9688 11.3427 9.31283 10.9173 10.4244C10.4919 11.536 9.06095 12.086 9.06095 12.086C9.06095 12.086 7.63048 12.6182 7.20459 13.7476C6.77917 14.8592 5.95645 12.9121 5.95645 12.9121L5.97727 12.9127Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.318 12.6003C8.318 12.6003 9.22029 13.9079 10.9868 14.8285C12.8971 15.8243 15.093 17.8259 14.5841 17.3845",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3075 9.84581C11.3075 9.84581 13.2607 11.5736 14.1023 13.5924C14.944 15.6113 16.2294 16.6082 16.2294 16.6082",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3453 19.2768C16.4846 18.7547 14.8254 17.7121 14.011 17.013L15.1964 17.0804L15.1105 15.6164C15.1105 15.6164 17.2288 17.402 18.2437 18.3917C18.467 18.6116 18.4792 18.9328 18.2857 19.1593C18.0501 19.4026 17.632 19.4627 17.3453 19.2768Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07337 10.8378C9.52137 10.4398 9.78587 9.89428 9.33181 9.73954",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8241 6.76775C22.8241 6.76775 24.3664 5.16907 21.7719 5.61666C19.8679 5.94011 20.4924 5.1725 19.6855 4.97268C18.8786 4.77287 17.1383 5.20764 16.8516 5.80603C16.4541 6.65101 15.9044 6.95717 15.1514 7.07965C14.3983 7.20213 13.4389 8.03209 14.2667 8.23246C15.0944 8.43283 16.1289 7.9079 17.3871 8.36932C18.6452 8.83074 20.0771 8.24513 20.0771 8.24513C20.0771 8.24513 21.4877 7.67677 22.7671 8.12093C24.0465 8.5651 22.8236 6.78557 22.8236 6.78557L22.8241 6.76775Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0395 8.07475C21.0395 8.07475 21.6258 9.51642 21.3091 11.237C20.9673 13.1173 21.3112 15.8359 21.2649 15.2286",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6202 8.22435C16.6202 8.22435 16.8899 10.6023 18.1521 12.472C19.4142 14.3417 19.4584 15.8045 19.4584 15.8045",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1636 18.2379C21.2498 17.349 21.401 15.5884 21.3023 14.6054L20.5931 15.4242L19.3493 14.4284C19.3493 14.4284 19.5736 16.9477 19.7886 18.2547C19.8434 18.5413 20.1082 18.7623 20.4412 18.7712C20.8158 18.7812 21.1342 18.558 21.1636 18.2379Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8224 6.88372C17.8224 6.88372 18.6285 6.33486 19.6029 6.50349",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2854 19.1775L20.2251 22.1883",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5256 18.738L20.228 22.0812",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 37.1052C42.8197 37.1052 44.4016 38.6982 44.3168 36.4144C44.2362 34.7545 45.0308 35.4174 45.3814 34.7673C45.732 34.1171 45.5232 32.5786 44.8658 32.2402C43.9416 31.752 43.7052 31.2466 43.6603 30.5859C43.6155 29.9251 42.8286 28.9772 42.4775 29.6452C42.1264 30.3131 42.5591 31.2694 41.8451 32.2664C41.1312 33.2633 41.5756 34.5586 41.5756 34.5586C41.5756 34.5586 42.02 35.8539 41.3061 36.8508C40.5921 37.8478 42.8395 37.1414 42.8395 37.1414L42.8197 37.1052Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5958 35.3609C41.5958 35.3609 39.8607 35.5997 37.9182 35.0309C35.8101 34.422 32.6282 34.2478 33.314 34.3018",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1124 31.6137C42.1124 31.6137 39.3264 31.4323 36.974 32.1716C34.6216 32.9109 32.9401 32.7055 32.9401 32.7055",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8517 33.7096C30.8663 33.9328 32.8542 34.3602 34.0178 34.4626L33.1836 33.7273L34.5403 32.8367C34.5403 32.8367 31.5892 32.5974 30.0491 32.5563C29.7161 32.5474 29.4195 32.7355 29.3495 33.0188C29.2785 33.3378 29.4993 33.6467 29.8512 33.7274L29.8517 33.7096Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.475 32.845C43.475 32.845 43.9749 33.6249 43.6413 34.4181",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3497 33.0203C29.3497 33.0203 26.5737 32.4649 24.5608 30.6286",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.986 38.856C27.8904 39.3079 29.6787 40.1935 30.7523 40.543L30.1934 39.6368L31.7696 39.1086C31.7696 39.1086 29.0035 38.1791 27.5354 37.7833C27.2043 37.7032 26.868 37.819 26.7156 38.0644C26.5415 38.345 26.6573 38.6868 26.986 38.856Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7157 38.0643C26.7157 38.0643 25.0859 37.486 23.5865 36.6973",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6267 28.1514L22.6137 41.912",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75612 41.4087C9.75612 41.4087 8.93323 43.3653 8.07461 41.2033C7.45002 39.6359 6.99012 40.4792 6.37907 39.9637C5.76803 39.4483 5.32886 37.9571 5.80101 37.435C6.44537 36.7035 6.48094 36.1519 6.22656 35.5391C5.97218 34.9262 6.33564 33.7951 6.94668 34.3105C7.55773 34.826 7.55093 35.8596 8.63542 36.5838C9.71991 37.308 9.85071 38.6483 9.85071 38.6483C9.85071 38.6483 9.98151 39.9887 11.066 40.7129C12.1505 41.437 9.75565 41.4265 9.75565 41.4265L9.75612 41.4087Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2048 39.4251C10.2048 39.4251 11.9413 39.1328 13.5119 38.034C15.2305 36.85 18.1548 35.7517 17.5025 36.0016",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12882 36.053C8.12882 36.053 10.6544 35.0688 13.1741 35.0826C15.673 35.0959 17.1915 34.3879 17.1915 34.3879",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5017 34.4418C19.6341 34.9534 17.9623 35.9426 16.9098 36.3601L17.3721 35.4277L15.7384 34.9919C15.7384 34.9919 18.3917 33.9042 19.8212 33.4076C20.1363 33.3091 20.4882 33.3898 20.6688 33.6442C20.8698 33.9169 20.7978 34.2715 20.4809 34.4413L20.5017 34.4418Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3788 37.62C7.3788 37.62 7.2306 38.4895 7.87993 39.1307",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46988 32.6754C6.46988 32.6754 4.56155 33.9435 5.16217 31.7314C5.60092 30.1211 4.69171 30.6315 4.48181 29.9129C4.27192 29.1943 4.83126 27.7476 5.54554 27.5171C6.55357 27.2054 6.91976 26.7517 7.08258 26.1144C7.2454 25.477 8.26629 24.6844 8.45537 25.4024C8.64446 26.1205 8.01758 26.9771 8.48804 28.077C8.9585 29.1769 8.23933 30.3698 8.23933 30.3698C8.23933 30.3698 7.52015 31.5627 7.99061 32.6626C8.46107 33.7625 6.42826 32.6743 6.42826 32.6743L6.46988 32.6754Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07172 31.1846C8.07172 31.1846 9.72338 31.7278 11.7493 31.5146C13.9422 31.288 17.1179 31.6937 16.4117 31.6213",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40115 27.4322C8.40115 27.4322 11.1625 27.7556 13.298 28.9C15.4334 30.0444 17.1386 30.1434 17.1386 30.1434",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9304 31.6618C18.8879 31.7052 16.8454 31.7576 15.6818 31.6552L16.6554 31.0752L15.5392 29.9759C15.5392 29.9759 18.4681 30.268 20.0034 30.4873C20.3355 30.5318 20.5785 30.7879 20.5917 31.0734C20.5832 31.394 20.3055 31.654 19.9304 31.6618Z",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39048 29.402C7.44686 28.851 7.25349 28.2932 6.79276 28.3879",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7502 33.7169C20.7502 33.7169 23.4702 32.4706 24.0295 31.0239L20.8163 31.241",
    stroke: "#E8B5E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubLogo);
export default __webpack_public_path__ + "static/media/sub-logo.ed4620eceb573a7f858fad1d710ba4bf.svg";
export { ForwardRef as ReactComponent };